<template>
  <span>
    <span v-if="!menu" class="action"> 
      <button v-if="buttonType" @click.prevent="openMoveUpModal" >
        <i  v-if="!buttonType"  @click.stop="openMoveUpModal" class="fal fa-arrow-up"></i>
      </button>
      <i  v-if="!buttonType"  @click.stop="openMoveUpModal" class="fal fa-arrow-up"></i><span class="label">{{moveUpLabel}}</span>
    </span>
    <span v-if="menu"
      @click.stop="openMoveUpModal"
      :class="iconOnly ? 'action' : ''"
    >
      <i   class="fal fa-arrow-up"></i><span class="">{{moveUpLabel}}</span>
    </span>
    <div :class="[{ open: moveUpModalStatus }, 'modal', 'moveup-confirmation-modal']">
      <div class="shadow" @click="closeMoveUpModal"></div>
      <div class="body">
        <i class="fal fa-times exit" @click="closeMoveUpModal"></i>
          <div >
            <div class="heading">Are you sure you want to move this?</div>
            <div class="actions">
              <div class="left">
                <button class="secondary" @click.stop.prevent="closeMoveUpModal">Cancel</button>
              </div>
              <div class="right">
                  <button class="primary" @click.stop.prevent="doMoveUp">Confirm</button>
              </div>
            </div>
          </div>
      </div>
    </div>
  </span>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import RallyPaginationMixin from "../components/RallyPaginationMixin";  
//import ContentMixin from "../components/ContentMixin";  
import {findDefaultChannelObjOfType,grandParentContextId,grandParentContextType } from "../common";
import { eventBus } from "../main.js";
  export default {
    //mixins: [RallyPaginationMixin, ContentMixin],
    props: ['content', 'rallyId', 'channelId', 'menu', 'type', 'contextShare', 'iconOnly'],
    data: function() {
      return {
        moveUpModalStatus: false,
        isLoading: true,
        step: 1,
        cbChanges:[],
        page: 1
      };
    },
    created () {

    },
    computed: {
      ...mapState("rallies", ["allRallies", "rallyChannelsByRallyId", "ralliesByParent", "allRalliesByRallyId"]),
      ...mapState("shares", ["sharesByContentId"]),
      buttonType(){
        return this.type == 'button'
      },
      moveUpLabel(){
        if (this.iconOnly){
          return ""
        } else if (this.menu){
          return "Move Up"
        } else {
          return ""
        }
      }
    },
    methods: {
      ...mapActions("contents", ["flagContent",  "clearContentItemFromContexts", "setContentById", "moveContent"]),
      ...mapActions("shares", [ "fetchSharesByContentId"]),
      async doMoveUp() {
        //alert(this.channelId)
        //alert(this.contextShare + " " +  grandParentContextId(this.$route.path, this.channelId ) + " " +  grandParentContextType(this.$route.path))
        await this.moveContent({shareId: this.contextShare.id, destinationId: grandParentContextId(this.$route.path, this.channelId ), destinationType:  grandParentContextType(this.$route.path)})
        this.$store.dispatch('user/flashSuccess', 'File successfully moved!');
        this.closeMoveUpModal()
        this.$emit('perform', 'handleLightboxHide')
        window.location.reload();
        
      },
      closeMoveUpModal() {
        this.moveUpModalStatus = false;
      },
      openMoveUpModal() {
        this.moveUpModalStatus = true;
      }
    }
  }
</script>
